import { createListenerMiddleware, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import { RootState } from '@/store'
import { storeActions, ThunkExtra } from '@/store/actions'
import { getDashboardTasks } from '@/store/dashboard-tasks/thunks'

const instance = createListenerMiddleware<
  RootState,
  ThunkDispatch<RootState, ThunkExtra, UnknownAction>
>()

instance.startListening({
  actionCreator: storeActions.initDashboard,
  effect: (_, listenerApi) => {
    listenerApi.cancelActiveListeners()
    listenerApi.dispatch(getDashboardTasks() as unknown as UnknownAction)
  },
})

export const dashboardTasksMiddleware = instance.middleware
